module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M18.15,4.88,13.56.29H2.15a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2H12.83a7,7,0,0,1-.68-3h-9l3-4,2,2,4-5,1.28,3a7,7,0,0,1,4.72-2.9ZM5.65,13.29a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,5.65,13.29Zm6.5-7v-5l5,5Z\" />\n  <polygon points=\"22.44 17.59 20.15 19.88 20.15 14.29 18.15 14.29 18.15 19.88 15.85 17.59 14.44 19 19.15 23.71 23.85 19 22.44 17.59\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/download.svg
// module id = 791
// module chunks = 1